var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images-slider__image",class:{ 'images-slider__image--not-draggable': !_vm.draggable }},[_c('img',{attrs:{"draggable":_vm.draggable,"src":_vm.imageUrl},on:{"dragstart":_vm.onDragStart,"dragenter":_vm.onDragEnter,"dragleave":_vm.onDragLeave,"dragend":_vm.onDragEnd}}),_vm._v(" "),_c('div',{staticClass:"images-slider__image__price"},[_vm._v("\n\t\t€ "+_vm._s(_vm.price)+"\n\t")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709c8966","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/apps/participate/playset-image.vue
// module id = 356
// module chunks = 0 1